import type { Campaign, CampaignCreative } from './campaignsApi';
import type { AdChannel } from './campaignChannels';

export function campaignTextList(value: string[] | string | undefined): string[] {
  if (Array.isArray(value)) return value.filter(item => typeof item === 'string' && item.trim());
  try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? campaignTextList(parsed) : []; }
  catch { return []; }
}

export function campaignPublicationChecks(channel: AdChannel, campaign: Campaign, creatives: CampaignCreative[]) {
  const published = channel === 'meta' ? campaign.meta_campaign_id : campaign.google_campaign_id;
  const checks = [{ label: 'Conta de anúncios definida', ready: Boolean(channel === 'meta' ? campaign.meta_ad_account_id : campaign.google_customer_id) }];
  const dailyBudget = Number(campaign.budget?.daily);
  checks.push({ label: 'Orçamento diário definido', ready: Number.isFinite(dailyBudget) && dailyBudget > 0 });
  if (channel === 'meta') checks.push({ label: 'Artes ou vídeos revisados', ready: Boolean(published || creatives.some(item => item.assetUrl)) });
  else {
    checks.push({ label: 'Pelo menos 3 títulos e 2 descrições', ready: campaignTextList(campaign.google_headlines).length >= 3 && campaignTextList(campaign.google_descriptions).length >= 2 });
    checks.push({ label: 'Palavras-chave definidas', ready: Boolean(campaignTextList(campaign.google_keywords).length) });
    let validUrl = false;
    try { validUrl = new URL(campaign.landing_url || '').protocol === 'https:'; } catch { /* Sem URL válida. */ }
    checks.push({ label: 'Site ou checkout com HTTPS', ready: validUrl });
  }
  return checks;
}

export function campaignIsApproved(status: string) {
  return ['pronta_publicacao', 'pausada', 'paused', 'ativa', 'active', 'running', 'publicada'].includes(status);
}
